// extracted by mini-css-extract-plugin
var _1 = "BrandButton_root__7a745";
var _2 = "BrandButton_secondary__6e395";
export { _1 as "root", _2 as "secondary" }
